import { render, staticRenderFns } from "./bgaChangeTask.vue?vue&type=template&id=afbbf5b4&scoped=true"
import script from "./bgaChangeTask.vue?vue&type=script&lang=js"
export * from "./bgaChangeTask.vue?vue&type=script&lang=js"
import style0 from "./bgaChangeTask.vue?vue&type=style&index=0&id=afbbf5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbbf5b4",
  null
  
)

export default component.exports